import { decodeFromBase64 } from '../../../../utils';
import { fetchPromoData } from './fetchPromoData';
import type { PromotionDataFetchInformation } from './fetch.types';

export const fetchSelectedPromotionData = async ({
  query,
  locale,
  callOwnApi,
}: Pick<PromotionDataFetchInformation, 'query' | 'locale' | 'callOwnApi'>) => {
  const { BonusNumber, P1, ParentCode, TestDate: testDate } = query;
  const selectedBonusNumber = BonusNumber || (P1 && decodeFromBase64(P1));
  if (!selectedBonusNumber) {
    return undefined;
  }
  try {
    return await fetchPromoData(
      { cart: selectedBonusNumber, texts: ParentCode || selectedBonusNumber },
      locale,
      callOwnApi,
      testDate,
    );
  } catch {
    return undefined;
  }
};
